module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/candle_7a5985.png";